import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}
export function CtaButton({
  href,
  children,
  className = ''
}: CtaButtonProps) {
  return <a href={href} className={`inline-flex w-full items-center justify-center rounded-lg border-2 border-b-[5px] border-navy bg-volt px-4 py-3 text-center font-display text-base font-extrabold uppercase leading-tight text-navy shadow-lg shadow-navy/25 transition-[filter,transform] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:brightness-105 active:translate-y-px active:scale-[0.99] sm:text-xl ${className}`} data-id="element-160" data-mp="1vvhde7s5cuuj">
      {children}
    </a>;
}